const kformBuilderOptionLabelPositionController = /* @ngInject */ (/** @type {any} */ $scope) => {
	$scope.labelPositions = [
		{
			value: 'top',
			title: 'Top',
		},
		{
			value: 'left-left',
			title: 'Left (Left-aligned)',
		},
		{
			value: 'left-right',
			title: 'Left (Right-aligned)',
		},
		{
			value: 'right-left',
			title: 'Right (Left-aligned)',
		},
		{
			value: 'right-right',
			title: 'Right (Right-aligned)',
		},
		{
			value: 'bottom',
			title: 'Bottom',
		},
	];

	$scope.labelAtTheTopOrBottom = () => !['top', 'bottom'].includes($scope.component.labelPosition);

	if (!$scope.component.labelPosition) {
		$scope.component.labelPosition = 'top';
	}
};

export default kformBuilderOptionLabelPositionController;
